module.exports = __webpack_public_path__ + "static/img/logo_footer.599ef3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_footer.png
// module id = i8Qq
// module chunks = 0